import { informes, procedimientos } from "./models";

var documentos = [];

var procedimientoOtros = {
  id: "otros",
  icon: "fa band-aid",
  text: "OTROS",
  description: "otros",
  isSelected: false,
  informes: [],
};
var procedimiento4 = {
  id: "procedimiento_4",
  icon: "fa band-aid",
  text: "P.4 FORMACIÓN",
  description: "procedimiento",
  isSelected: false,
  informes: [
    {
      id: "formacion",
      title: "Acta de formación",
      full_title: "RE.4.5 Acta de formación",
      procedimiento: "P.4",
      procedimiento_num: "4",
      registro: "05",
      registro_num: "05",
      revision: "",
      revision_num: "",
    },
  ],
};
var procedimiento5 = {
  id: "procedimiento_5",
  icon: "fa band-aid",
  text: "P.5 CONTROL DEL AGUA",
  description: "procedimiento",
  isSelected: false,
  informes: [
    {
      id: "agua_cloro",
      title: "Control del cloro",
      full_title: "RE.5.7 Control del cloro",
      procedimiento: "P.5",
      procedimiento_num: "5",
      registro: "07",
      registro_num: "07",
      revision: "",
      revision_num: "",
    },
  ],
};
var procedimiento12 = {
  id: "procedimiento_12",
  icon: "fa band-aid",
  text: "P.12 COMPRAS",
  description: "procedimiento",
  isSelected: false,
  informes: [
    {
      id: "visita_campo",
      title: "Visita a campo",
      full_title: "RE.12.1 Visita a campo",
      procedimiento: "P.12",
      procedimiento_num: "12",
      registro: "1",
      registro_num: "1",
      revision: "",
      revision_num: "",
    },
  ],
};

var procedimiento15 = {
  id: "procedimiento_15",
  icon: "fa band-aid",
  text: "P.15 IDENTIFICACIÓN Y TRAZABILIDAD",
  description: "procedimiento",
  isSelected: false,
  informes: [
    {
      id: "multiresiduos",
      title: "Control de análisis",
      full_title: "RE.15.1 Control de análisis",
      procedimiento: "P.15",
      procedimiento_num: "15",
      registro: "1",
      registro_num: "1",
      revision: "",
      revision_num: "",
    },
  ],
};

var procedimiento17 = {
  id: "procedimiento_17",
  icon: "fa band-aid",
  text: "P.17 CONFECCIÓN DE POMELOS",
  description: "procedimiento",
  isSelected: false,
  informes: [
    {
      id: "control_enmalladoras",
      title: "Control peso enmalladoras",
      full_title: "RE.17.31 Control peso enmalladoras",
      procedimiento: "P.17",
      procedimiento_num: "17",
      registro: "31",
      registro_num: "31",
      revision: "Rev.",
      revision_num: "",
    },
    {
      id: "inspeccion_pomelo_recibido",
      title: "Inspección pomelo recibido",
      full_title: "RE.17.27 Inspección pomelo recibido",
      procedimiento: "P.17",
      procedimiento_num: "17",
      registro: "27",
      registro_num: "27",
      revision: "Rev.",
      revision_num: "",
    },
    {
      id: "inspeccion_pomelo_recibido_i",
      title: "Inspección pomelo recibido importación",
      full_title: "RE.17.27bis Inspección pomelo recibido importación",
      procedimiento: "P.17bis",
      procedimiento_num: "17bis",
      registro: "27bis",
      registro_num: "27bis",
      revision: "Rev.",
      revision_num: "",
    },
    {
      id: "inspeccion_pomelo_acabado",
      title: "Inspección pomelo acabado",
      full_title: "RE.17.32 Inspección pomelo acabado",
      procedimiento: "P.17",
      procedimiento_num: "17",
      registro: "32",
      registro_num: "32",
      revision: "Rev.",
      revision_num: "",
    },
    {
      id: "registro_etiquetas",
      title: "Registro etiquetas",
      full_title: "RE.17.32.1 Registro etiquetas",
      procedimiento: "P.17",
      procedimiento_num: "17",
      registro: "32.1",
      registro_num: "32.1",
      revision: "Rev.",
      revision_num: "",
    },
  ],
};

var procedimiento8 = {
  id: "procedimiento_8",
  icon: "fa band-aid",
  text: "P.08 SEGUIMIENTO Y MEDICIÓN",
  description: "P.08",
  isSelected: false,
  informes: [
    {
      id: "control_calidad_interna_citricos",
      title: "RE.08.01 Control calidad interna-cítricos",
      full_title: "RE.08.01 Control calidad interna-cítricos",
      procedimiento: "P.08",
      procedimiento_num: "08",
      registro: "01",
      registro_num: "01",
      revision: "",
      revision_num: "",
    },

    {
      id: "control_linea_citricos",
      title: "Control de línea cítricos",
      full_title: "RE.08.03 Control de línea cítricos",
      procedimiento: "P.08",
      procedimiento_num: "08",
      registro: "03",
      registro_num: "03",
      revision: "",
      revision_num: "",
    },
  ],
};

var procedimiento18 = {
  id: "procedimiento_18",
  icon: "fa band-aid",
  text: "P.18 MANTENIMIENTO Y AVERÍAS",
  description: "P.18",
  isSelected: false,
  informes: [
    {
      id: "parte-ejecucion",
      title: "Parte de ejecución",
      full_title: "RE.18.1 Parte de ejecución",
      procedimiento: "P.15",
      procedimiento_num: "15",
      registro: "2",
      registro_num: "2",
      revision: "",
      revision_num: "",
    },
  ],
};

export var formularios = [
  [
    {
      procedimiento: "",
      referencia: "",
      referencia_num: "",
      revision: "",
      titulo: "",
    },
  ],
];

export function getProcedimiento(procedure: string): any {
  rellenarProcedimientos();
  let respuesta: any = [];

  /*  for (let index = 0; index < documentos.length; index++) {
        const element = documentos[index];
        if (element.id.localeCompare(procedure ) == 0) {
            index = documentos.length;
            respuesta = element;
        }
        
    } */
  respuesta = documentos.find((doc) => doc.id.localeCompare(procedure) == 0);

  // console.log('procedimiento', respuesta);
  return respuesta;
}

export function getDocumento(documento: string) {
  rellenarProcedimientos();
  let respuesta: any;
  for (let index = 0; index < documentos.length; index++) {
    const element = documentos[index]["informes"];

    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];
      if (element2.id.localeCompare(documento) == 0) {
        index2 = element.length;
        index = documentos.length;
        respuesta = element2;
      }
    }
  }
  // console.log('documentos', respuesta);
  return respuesta;
}

function rellenarProcedimientos() {
  documentos = [];
  documentos.push(procedimiento4);
  documentos.push(procedimiento5);
  documentos.push(procedimiento12);
  documentos.push(procedimiento15);
  documentos.push(procedimiento17);
  documentos.push(procedimiento18);
  //documentos.push(procedimientoOtros);
}

export function rellenarMenUsuario() {
  rellenarProcedimientos();
  let respuesta: any[] = [];
  /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
  for (let index = 0; index < documentos.length; index++) {
    const element: informes[] = documentos[index]["informes"];
    // console.log('element', element[0]);
    // console.log(' documentos[index]',  documentos[index]);
    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];
      let menu = {
        id: element2.id,
        icon: "fa band-aid",
        text: element2.full_title,
        description: element2.full_title,
        isSelected: false,
      };
      respuesta.push(menu);
    }
  }
  // respuesta.unshift({id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false })
  // console.log('documentos', respuesta);
  return respuesta;
}

export function rellenarMenSinIdVacio() {
  rellenarProcedimientos();
  let respuesta: any[] = [];
  /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
  for (let index = 0; index < documentos.length; index++) {
    const element: informes[] = documentos[index]["informes"];
    // console.log('element', element[0]);
    // console.log(' documentos[index]',  documentos[index]);
    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];
      if (element2.id == null || (element2.id as string).length == 0) {
      } else {
        let menu = {
          id: element2.id,
          icon: "fa band-aid",
          text: element2.full_title,
          description: element2.full_title,
          isSelected: false,
        };
        respuesta.push(menu);
      }
    }
  }
  // respuesta.unshift({id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false })
  // console.log('documentos', respuesta);
  return respuesta;
}

export function rellenarMenuAdmin() {
  rellenarProcedimientos();
  let respuesta: any[] = [];
  let respuesta_item_menu: any[] = [];
  /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
  for (let index = 0; index < documentos.length; index++) {
    respuesta_item_menu = [];
    const element: informes[] = documentos[index]["informes"];
    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];

      /*   let item_menu = {id: element2.id, fatherId: documentos[index].id, text: element2.full_title,  isSelected: false }
            respuesta.push(item_menu); */
      let item_menu = {
        id: element2.id,
        fatherId: documentos[index].id,
        text: element2.full_title,
        description: element2.full_title,
        isSelected: false,
      };
      respuesta_item_menu.push(item_menu);
    }

    respuesta_item_menu.push({
      id: "",
      fatherId: "",
      text: "",
      description: "",
      isSelected: false,
    });
    let proce = {
      id: documentos[index]["id"],
      icon: documentos[index]["icon"],
      text: documentos[index]["text"],
      description: documentos[index]["description"],
      isSelected: documentos[index]["isSelected"],
      expandable: respuesta_item_menu,
    };

    //const element: procedimientos[] = documentos[index]['informes'];
    // console.log('element', element[0]);
    // console.log(' documentos[index]',  documentos[index]);
    respuesta.push(proce);
  }
  respuesta.unshift({
    id: "clientes",
    icon: "fa fa-quora",
    text: "Inicio",
    description: "Inicio",
    isSelected: false,
  });
  // console.log('documentos', respuesta);
  return respuesta;
}
